import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForm = this.svg
      .append('g')
      .attr('transform', `translate(0,0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')
      
      this.canvasForm
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/TrionFPU_r1.svg').attr('x', 20).attr('y', 20).attr('width', 230)

      this.canvasForm
      .append('text')
      .attr('id', 'TITLE')
      .attr('transform', `translate(20, 90)`)
      .attr('font-size', 20).attr('fill', '#000')
      .text('3D System Boundary')

      this.canvasForm
      .append('text')
      .attr('transform', `translate(20, 105)`)
      .attr('font-size', 12)
      .attr('fill', '#757575')
      .text('3D System Boundary with Status of System Completion')

      this.canvasForm
      .append('text')
      .attr('x', 1560).attr('y', 50)
      .attr('fill', '#333').attr('font-size', 12)
      .attr('text-anchor', 'end')
      .text(this.updated + ' ' + this.cutoff1)

      if (this.current.mouseover) {
        this.canvasForm
        .append('image')
        .attr('id', 'KEY_PLAN')
        .attr('xlink:href', this.Boundary + `keyplan/KP_${this.current.mouseover}.svg`).attr('x', 20).attr('y', 110).attr('width', 280)
        .on('error', ()=> {
          d3.select(`#KEY_PLAN`).attr('xlink:href', this.Boundary + `keyplan/KP_0000.svg`)
        })
      } else {
        this.canvasForm
        .append('image')
        .attr('id', 'KEY_PLAN')
        .attr('xlink:href', this.Boundary + `keyplan/KP_0000.svg`).attr('x', 20).attr('y', 110).attr('width', 280)
      }

      this.canvasForm
      .append('rect')
      .attr('id', `BOTTOM`)
      .attr('x', 0).attr('y', this.Canvas.CanvasHeight-10)
      .attr('width', this.Canvas.CanvasWidth).attr('height', 10)
      .attr('fill', '#44A9DF')

      this.draw_Handover()
      this.draw_Search()
      this.draw_SystemList()

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}